
import React, { PureComponent } from 'react'
import { Dialog, DialogFooter, PrimaryButton, DefaultButton, DialogType, TextField } from 'office-ui-fabric-react'


/**
 * @typedef {object} EmailManagerModalProps
 * @property {boolean} show show
 * @property {function} sendEmail sendEmail
 * @property {function} cancel cancel
 * @property {string} manager manager
 */


/**
 * @extends {PureComponent<EmailManagerModalProps>}}
 */
export default class EmailManagerModal extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            contenu: '',
        }
    }
    /**
     * @inheritdoc
     * @param {object} prevProps Previous Props
     */
    componentDidUpdate(prevProps) {
        /** Scrool to top of modal on creation */
        if (prevProps?.show !== this.props?.show && this.props?.show === true) {
            setTimeout(() => document.querySelector('.ms-Modal-scrollableContent').scrollTop = 0, 50)
        }
    }

    /**
     * Render component
     */
    render() {
        const { show, cancel, sendEmail, manager } = this.props
        const { contenu } = this.state

        if (!show)
            return null

        return (
            <Dialog
                hidden={!show}
                onDismiss={() => cancel()}
                dialogContentProps={{
                    type: DialogType.largeHeader,
                    title: 'Envoyer email au manager',
                    subText: `Les informations suivantes seront envoyées au manager : ${manager}`
                }}
                modalProps={{
                    isBlocking: true
                }}
                maxWidth={"555px"}
            >
                <TextField
                    value={contenu}
                    onChange={(ev, newVal) => this.setState({ contenu: newVal })}
                    multiline
                    rows={5}
                />
                <DialogFooter>
                    <DefaultButton
                        onClick={() => cancel()}
                        text="Annuler"
                    />
                    <PrimaryButton
                        onClick={() => {
                            sendEmail(contenu)
                            this.setState({ contenu: '' }) // Reset content after sending
                        }}
                        text="Envoyer l'email"
                    />
                </DialogFooter>
            </Dialog>
        )
    }
}
